import React from 'react'
import {Row, Col, Radio, Icon} from 'antd';
import isEqual from 'lodash/isEqual';
import "./style/index.less";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: props.datas || [],
      showMore: false,
      shouldShowMore: false,
      values: props.values || [],
    }
  }

  componentWillReceiveProps(nextProps) {
    const { values, datas } = this.state;
    if (nextProps.datas && !isEqual(nextProps.datas, datas)) {
      let showMore = this.state.showMore;
      this.setState({showMore: true},() => {
        this.setState({datas: nextProps.datas,shouldShowMore:this.refs.radios.offsetHeight > 42},
          () => {
            if(this.state.shouldShowMore) {this.setState({showMore:showMore})}
          });
      })
    }
    if (nextProps.values && !isEqual(values, nextProps.values)) {
      this.setState({values: nextProps.values});
    }
  }

  render() {
    let {datas,showMore, shouldShowMore, values} = this.state;
    let style = showMore ? {} : {height:40,overflow:'hidden'};
    return (
      <div className='cs-radio-group' ref='radios'>
        {
          datas && datas.map((item, index) => {
            const dataLen = datas.length - 1;
            const checkedValue = !values || values.length === 0 ? item.defaultValue : values[index];
            return (
              <Row key={item.key}>
                <Col span={2}
                     className={`cs-radio-group-title ${dataLen !== index && 'cs-radio-group-not-last'}`}>
                  {item.name}:
                </Col>
                <Col span={22}
                     className={`cs-radio-group-content ${dataLen !== index && 'cs-radio-group-not-last'}`}>
                  <Row>
                    <Col span={22} style={style}>
                      <RadioGroup
                        value={checkedValue}
                        onChange={(e) => {
                          datas[index].defaultValue = e.target.value;
                          this.setState({datas: datas});
                          typeof this.props.onChange === 'function' && this.props.onChange(e, item);
                        }}
                      >
                        {
                          item.data && item.data.map(c => {
                            return (
                              <span key={c.key} ref={'cs-radio'}
                                    style={{display: 'inline-block', minWidth: 101, textAlign: 'center'}}>
                              <RadioButton value={c.key}>{c.name}</RadioButton>
                            </span>
                            )
                          })
                        }
                      </RadioGroup>
                    </Col>
                    {
                      shouldShowMore && (
                        <Col span={2}>
                          {
                            showMore ? (
                              <div className='cs-radio-group-more'
                                   onClick={() => {
                                     this.setState({showMore:!showMore});
                                   }}>
                                <span>收起</span>
                                <Icon type="up" />
                              </div>
                            ) : (
                              <div className='cs-radio-group-more'
                                   onClick={() => {
                                     this.setState({showMore:!showMore});
                                   }}>
                                <span>更多</span>
                                <Icon type="down"/>
                              </div>
                            )
                          }
                        </Col>
                      )
                    }
                  </Row>
                </Col>
              </Row>
            )
          })
        }
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/public/cs-radio-group/index.js